import React, { useState } from "react";
// --- MODIFICATION START ---
// We no longer need Link for the back button, but we need useNavigate
import { useNavigate } from "react-router-dom";
// --- MODIFICATION END ---

const API_URL = "http://localhost:8000/contact";

const ContactUsPage = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState("");
  // --- MODIFICATION START ---
  const navigate = useNavigate();

  // This function will take the user to the previous page in their history
  const handleGoBack = () => {
    navigate(-1);
  };
  // --- MODIFICATION END ---

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus(
          "Thank you for your message! We will get back to you shortly."
        );
        setFormData({
          fullName: "",
          email: "",
          subject: "",
          message: "",
        });
      } else {
        const errorData = await response.json();
        console.error("Server error:", errorData);
        setStatus(
          `Oops! There was a problem: ${
            errorData.detail || "Please try again."
          }`
        );
      }
    } catch (error) {
      console.error("Network error:", error);
      setStatus(
        "Oops! There was a network problem. Please check your connection and try again."
      );
    }
  };

  return (
    <div className="bg-white min-h-screen">
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#073214]">
            Contact Us
          </h1>
          <p className="mt-4 max-w-2xl mx-auto text-lg text-gray-600">
            Have a question or want to work together? We’d love to hear from
            you.
          </p>
        </div>

        <div className="relative bg-white shadow-xl rounded-lg overflow-hidden lg:grid lg:grid-cols-2 lg:gap-4">
          {/* Contact Information */}
          <div className="pt-16 pb-12 px-6 sm:px-10 lg:p-16 bg-gray-50 flex flex-col justify-between">
            <div>
              <h2 className="text-2xl font-bold text-[#073214]">
                Get in touch directly
              </h2>
              <p className="mt-2 text-base text-gray-600">
                Find our contact information below. For general inquiries,
                please use the contact form.
              </p>
              <dl className="mt-8 space-y-6 text-base text-gray-600">
                <dt className="sr-only">Email</dt>
                <dd className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  <a
                    href="mailto:info@skillmatchai.ca"
                    className="ml-3 font-semibold text-[#e55812] hover:text-orange-700"
                  >
                    info@skillmatchai.ca
                  </a>
                </dd>
              </dl>
            </div>

            {/* --- MODIFICATION START: Replaced <Link> with <button> --- */}
            <div className="mt-12 pt-8 border-t border-gray-200">
              <button
                onClick={handleGoBack}
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 mr-2 text-gray-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                Go Back
              </button>
            </div>
            {/* --- MODIFICATION END --- */}
          </div>

          {/* Contact Form */}
          <div className="pt-16 pb-12 px-6 sm:px-10 lg:p-16">
            <h2 className="text-2xl font-bold text-[#073214]">
              Send us a message
            </h2>
            <form
              onSubmit={handleSubmit}
              className="mt-8 grid grid-cols-1 gap-y-6"
            >
              {/* Form inputs remain the same */}
              <div>
                <label htmlFor="fullName" className="sr-only">
                  Full Name
                </label>
                <input
                  type="text"
                  name="fullName"
                  id="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                  className="block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-green-700 focus:border-green-700 border-gray-300 rounded-md"
                  placeholder="Full Name"
                />
              </div>
              <div>
                <label htmlFor="email" className="sr-only">
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-green-700 focus:border-green-700 border-gray-300 rounded-md"
                  placeholder="Email Address"
                />
              </div>
              <div>
                <label htmlFor="subject" className="sr-only">
                  Subject
                </label>
                <input
                  type="text"
                  name="subject"
                  id="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className="block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-green-700 focus:border-green-700 border-gray-300 rounded-md"
                  placeholder="Subject"
                />
              </div>
              <div>
                <label htmlFor="message" className="sr-only">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={4}
                  value={formData.message}
                  onChange={handleChange}
                  required
                  className="block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-green-700 focus:border-green-700 border-gray-300 rounded-md"
                  placeholder="Your Message"
                />
              </div>
              <div>
                <button
                  type="submit"
                  className="w-full inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-[#073214] hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-700"
                >
                  Send Message
                </button>
              </div>
            </form>
            {status && (
              <p className="mt-6 text-center text-green-600 font-medium">
                {status}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsPage;
